<template>
    <main
        name="content-page"
        class="template template__main"
    >
        <slot name="hero">
            <BaseHero
                v-if="entry"
                :image="heroImage"
                :hero-event="heroEvent"
                :hero-link="heroLink"
            >
                <template
                    v-if="entry?.heroTitle"
                    #title
                >
                    {{ entry.heroTitle }}
                </template>
            </BaseHero>
        </slot>

        <slot name="filters">
            <Transition name="fade">
                <div
                    v-if="eventFiltersStore.filtersVisible"
                    class="template__filters"
                >
                    <FilterState />
                </div>
            </Transition>
        </slot>

        <slot name="default">
            <FlexibleSections
                v-if="entry?.flexibleSections || entry?.heroTitle"
                :sections="entry.flexibleSections ?? []"
            />
        </slot>
    </main>
</template>

<script lang="ts" setup>
import type { PageEntryTypeFragment, ProgramOverviewEntryTypeFragment, UpdateEntryTypeFragment } from '~/types/craft-schema';
import type { MediaAssetExtended } from '~/types/craft-schema.extended';
import { useEventFiltersStore } from '~/stores/eventFilters';

const props = withDefaults(
    defineProps<{
        entry?: PageEntryTypeFragment | ProgramOverviewEntryTypeFragment | UpdateEntryTypeFragment | null;
    }>(),
    {
        entry: undefined
    }
);

const eventFiltersStore = useEventFiltersStore();

const heroEvent = computed(() => {
    if (!props.entry || props.entry.__typename === 'updates_default_Entry') {
        return null;
    }

    if (props.entry.heroEvent.length > 0) {
        return props.entry.heroEvent[0];
    }

    return null;
});

const heroImage = computed(() => {
    if (props.entry && props.entry.heroImages.length > 0) {
        return props.entry.heroImages[0] as MediaAssetExtended;
    }

    return null;
});

const heroLink = computed(() => {
    if (!props.entry || props.entry.__typename === 'updates_default_Entry') {
        return null;
    }

    return props.entry?.heroLink;    
});

const toggleEventFilters = () => {
    if (
        props.entry &&
        props.entry.__typename === 'page_programOverview_Entry'
    ) {
        eventFiltersStore.filtersVisible = true;
    } else {
        eventFiltersStore.filtersVisible = false;
    }
};

onMounted(() => {
    toggleEventFilters();
});

onBeforeUnmount(() => {
    eventFiltersStore.filtersVisible = false;
});
</script>
